// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types.js';

const SUPABASE_URL = (typeof process !== 'undefined' && process.env?.VITE_SUPABASE_URL) || 
  (typeof window !== 'undefined' ? (import.meta as any).env?.VITE_SUPABASE_URL : undefined);
const SUPABASE_PUBLISHABLE_KEY = (typeof process !== 'undefined' && process.env?.VITE_SUPABASE_PUBLISHABLE_KEY) || 
  (typeof window !== 'undefined' ? (import.meta as any).env?.VITE_SUPABASE_PUBLISHABLE_KEY : undefined);

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const isSupabaseConfigured = !!(SUPABASE_URL && SUPABASE_PUBLISHABLE_KEY);

if (!isSupabaseConfigured) {
  console.warn("Missing Supabase environment variables. The app will show a maintenance screen.");
}

export const supabase = isSupabaseConfigured
  ? createClient<Database>(SUPABASE_URL!, SUPABASE_PUBLISHABLE_KEY!, {
      auth: {
        storage: typeof localStorage !== 'undefined' ? localStorage : undefined,
        persistSession: typeof localStorage !== 'undefined',
        autoRefreshToken: typeof localStorage !== 'undefined',
      }
    })
  : null as unknown as ReturnType<typeof createClient<Database>>;